// Actions that identify the current user as the maker of a MAKER_CHECKER task.
export const MAKER_ROLE_ACTIONS = new Set([
  "start_work",
  "submit_for_review",
  "start_and_submit",
  "complete",
]);

// Subset of maker actions that trigger obsolete-document detachment on submit.
export const MAKER_SUBMISSION_ACTIONS = new Set([
  "submit_for_review",
  "start_and_submit",
  "complete",
]);

// Actions that dismiss the task detail panel after completion.
export const TASK_CLOSE_ACTIONS = new Set([
  "complete",
  "skip",
  "approve",
  "approve_on_behalf",
  "reject",
  "submit_for_review",
  "start_and_submit",
]);
